import Vue from 'vue';
import { debounce } from 'lodash-es';

const observable = Vue.observable({
    width: window.innerWidth,
    height: window.innerHeight,
});

const onResizeDebouncedFunc = debounce(() => {
    observable.width = window.innerWidth;
    observable.height = window.innerHeight;
}, 200);

window.addEventListener('resize', onResizeDebouncedFunc);

export const ScreenUtil = observable;
